/* @ngInject */
function CampaignPostsController ($rootScope, $scope, $q, $translate, $location, Utils, CONSTANTS, CampaignService, SliderService, ToastService, UdsModalService, ModalService, PostsService) {
  const getBindCampaignDialogController = () => $q.when(import('../../../core/dialogs/bind-campaign/bind-campaign-dialog.controller'))

  $scope.posts = []
  $scope.totalCount = 0

  const api = {
    _bindPostToCampaign,
    _unbindPostFromCampaign
  }

  this.getApi = () => api

  activate()

  function activate () {
    CampaignService.getCampaignPosts($scope.campaign.id)
      .then(posts => {
        $scope.posts = posts
        $scope.totalCount = posts.length
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  $scope.emptyState = {
    imgPath: 'campaign-posts',
    title: $translate.instant('campaignEdit.posts.emptyState.title'),
    message: $translate.instant('campaignEdit.posts.emptyState.message'),
    button: {
      icon: 'plus',
      type: 'primary',
      text: $translate.instant('add'),
      click: () => $scope.createNewPost(),
      disabled: $scope.campaign.status === 'FINISHED',
      tooltip: {
        text: $translate.instant('campaignErrors.campaignFinished'),
        position: 'bottom',
        disabled: $scope.campaign.status !== 'FINISHED'
      }
    }
  }

  const deregisterUnselectPostFloatingToolBar = $rootScope.$on('campaign.select-post-floating-tool-bar', function (event, info) {
    $scope.selectedPost = info?.post
    $scope.action = info?.action
  })

  $scope.$on('$destroy', () => {
    deregisterUnselectPostFloatingToolBar()
  })

  $scope.getThumbnail = function (thumbnailId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [thumbnailId])
  }

  $scope.openPostDetails = function (post, _openResults) {
    if ($rootScope.isDesktop) {
      $location.search({ company: $rootScope.oUserCompany.id, post: post.id })

      if (_openResults) {
        if (window.clarity) {
          window.clarity('set', 'announcement-list-results-btn', null)
        }
      }

      ModalService.showModal({
        templateId: 'newPost.html',
        templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
        destroyable: true,
        closable: true,
        data: {
          _postId: post.id,
          _editMode: false,
          _openResults
        }
      }).then(function (hasUpdatedPost) {
        if (hasUpdatedPost) {
          $scope.$emit('campaign.reload-actions')
        }
      })
    }
  }

  $scope.$on('campaignDataUpdated', function () {
    activate()
  })

  $scope.createNewPost = function () {
    $('.sidebar-menu-second-level').transition('slide down')
    if ($rootScope.isDesktop) {
      ModalService.showModal({
        templateId: 'newPost.html',
        templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
        destroyable: true,
        data: {
          _selectedCampaignId: $scope.campaign.id,
          _editMode: true
        }
      }).then(function () {
        activate()
      })
    } else {
      SliderService.setState('post-slider', 'open', {
        _editMode: true,
        _existingPost: false
      })
    }
  }

  $scope.openBindCampaignDialog = (postId) => {
    getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
      const bindCampaignDialog = UdsModalService.createModal({
        controller: BindCampaignDialogController,
        modalName: 'bindCampaignDialog',
        data: {
          currentModule: 'requests',
          assetId: postId,
          campaignId: $scope.campaign.id,
          campaignName: $scope.campaign.title
        },
        onClose: (bindDetails) => {
          if (bindDetails) {
            if (bindDetails.selectedCampaign) {
              api._bindPostToCampaign(bindDetails)
            } else {
              api._unbindPostFromCampaign(bindDetails)
            }
          }
        }
      })

      bindCampaignDialog.open()
    })
  }

  $scope.selectPost = (post) => {
    if (post.isArchived) return

    if ($scope.selectedPost?.id === post.id) {
      $scope.selectedPost = null
    } else {
      $scope.selectedPost = post
    }
  }

  function _bindPostToCampaign (bindDetails) {
    PostsService.bindPostToCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        activate()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _unbindPostFromCampaign (bindDetails) {
    PostsService.unbindPostFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        activate()
        $scope.$emit('campaign.reload-actions')
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }
}

export { CampaignPostsController }
